import moment from 'moment';
import { FORM_MAP } from '@/pages/dashboard/pages/ua/_config/constant';

export const timeRange = (isPUBGM?: boolean) => {
    const val = isPUBGM ? 2 : 1;
    const currDate = moment();
    const currWeek = currDate.week();
    const currMonth = currDate.month();

    return {
      Day: [
        moment().subtract(val, 'day').format('YYYY-MM-DD'),
        moment().subtract(val, 'day').format('YYYY-MM-DD')
      ],
      Week: [
        moment().week(currWeek - val).startOf('isoWeek').format('YYYY-MM-DD'),
        moment().week(currWeek - val).endOf('isoWeek').format('YYYY-MM-DD')
      ],
      Month: [
        moment().month(currMonth - val).startOf('month').format('YYYY-MM-DD'),
        moment().month(currMonth - val).endOf('month').format('YYYY-MM-DD')
      ],
    }
  }

const getDefaultValue = (isPUBGM?: boolean) => {
  return {
    [FORM_MAP.RANGE_TIME_TYPE]: 'Day',
    [FORM_MAP.RANGE_TIME]: timeRange(isPUBGM)?.Day,
    [FORM_MAP.RANGE_TIME_DIFF]: false,
    [FORM_MAP.REGION]: {
      regions: [],
      markets: ['255'],
      region_type: 'market',
    },
    [FORM_MAP.SYSTEM]: ['255'],
    [FORM_MAP.NETWORK_TYPE]: ['255'],
    [FORM_MAP.MEDIA_CHANNEL]: ['255'],
  };
};

export default getDefaultValue;
